/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DownloadPluginPackageSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Target platform to download plugins for.
 */
export const QueryParamPlatform = {
  Claude: "claude",
  Cursor: "cursor",
  Codex: "codex",
  AgentPlugin: "agent-plugin",
} as const;
/**
 * Target platform to download plugins for.
 */
export type QueryParamPlatform = ClosedEnum<typeof QueryParamPlatform>;

export type DownloadPluginPackageRequest = {
  /**
   * The plugin to download.
   */
  pluginId: string;
  /**
   * Target platform to download plugins for.
   */
  platform: QueryParamPlatform;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type DownloadPluginPackageResponse = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type DownloadPluginPackageSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DownloadPluginPackageSecurity$outboundSchema: z.ZodMiniType<
  DownloadPluginPackageSecurity$Outbound,
  DownloadPluginPackageSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function downloadPluginPackageSecurityToJSON(
  downloadPluginPackageSecurity: DownloadPluginPackageSecurity,
): string {
  return JSON.stringify(
    DownloadPluginPackageSecurity$outboundSchema.parse(
      downloadPluginPackageSecurity,
    ),
  );
}

/** @internal */
export const QueryParamPlatform$outboundSchema: z.ZodMiniEnum<
  typeof QueryParamPlatform
> = z.enum(QueryParamPlatform);

/** @internal */
export type DownloadPluginPackageRequest$Outbound = {
  plugin_id: string;
  platform: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DownloadPluginPackageRequest$outboundSchema: z.ZodMiniType<
  DownloadPluginPackageRequest$Outbound,
  DownloadPluginPackageRequest
> = z.pipe(
  z.object({
    pluginId: z.string(),
    platform: QueryParamPlatform$outboundSchema,
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      pluginId: "plugin_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function downloadPluginPackageRequestToJSON(
  downloadPluginPackageRequest: DownloadPluginPackageRequest,
): string {
  return JSON.stringify(
    DownloadPluginPackageRequest$outboundSchema.parse(
      downloadPluginPackageRequest,
    ),
  );
}

/** @internal */
export const DownloadPluginPackageResponse$inboundSchema: z.ZodMiniType<
  DownloadPluginPackageResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function downloadPluginPackageResponseFromJSON(
  jsonString: string,
): SafeParseResult<DownloadPluginPackageResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DownloadPluginPackageResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DownloadPluginPackageResponse' from JSON`,
  );
}
